import businessClient from 'src/services/clients/business'
import { IMeta, ICategoryUpsertArgs, ICategory, ICategoryOverride } from 'src/common/interfaces/index.js'

const ICategoryListResponse = { meta: IMeta, data: { list: [ICategory], total_items: 0 } }
const ICategoryUpsertResponse = { meta: IMeta, data: { category: ICategory, category_override: ICategoryOverride } }
const ICategoryArchiveResponse = { meta: IMeta, data: ICategory }

export const inventoryCategory = {
  /**
   * @param {ICategoryUpsertArgs} data
   * @return {Promise<ICategoryUpsertResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/category/upsert', { data }, { signal })
  },

  /**
   * @param {{store_id: number}} filter
   * @return {Promise<ICategoryListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('inventory/category/portal/list', { filter }, { signal })
  },

  /**
   * @param {{id: number; store_id: number}} filter
   * @return {Promise<ICategoryArchiveResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('inventory/category/archive', { filter }, { signal })
  },

  /**
   * @param {{from: number; to: number}} filter
   */
  updateOrd(filter, signal) {
    return businessClient().post('inventory/category/update-ord', { filter }, { signal })
  },
}
